// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '77d8fc5e-8ddd-4aef-a454-b042047a440d',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '7c45033a-77c4-4506-b280-a8da0d62bd71',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Variation',
      parent: '77d8fc5e-8ddd-4aef-a454-b042047a440d',
      data: {
        DEBUG: true
      }
    },
    {
      id: '5d5c6767-f58f-4936-bddc-3c257e3e66cf',
      type: 'Sprite',
      name: 'mark',
      className: '',
      x: 96,
      y: 63,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Check',
      parent: '77d8fc5e-8ddd-4aef-a454-b042047a440d',
      stateByName: {
        locked: {
          texture: 'Gold_Lock'
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'locked'
  ],
  handleResize: false
} as const;

export class SeasonPassRewardWrapperLayout {
  static raw = raw;
  root!: Container;
  mark!: Sprite;
  StateName!: 'locked';

  constructor() {
    populate(this, raw);
  }
}
